<template>
    <div class="modal fade" id="viewScheduleModal" tabindex="-1" role="dialog" aria-labelledby="viewScheduleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="viewScheduleModalLabel">{{ __('schedules.view') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div v-if="schedule" class="modal-body">
                    <div v-if="schedule.is_blanco" class="alert alert-info mb-3">
                        Dit is een blanco vragenlijst (niet vooraf ingepland).
                    </div>
                    <div class="row">
                        <div class="col-md-6" v-if="!schedule.is_blanco">
                            <p class="fw-bold m-0">{{ __('form.instructor-name') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.instructor?.name }}</p>
                        </div>
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.questionnaire') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.questionnaire ? schedule.questionnaire.name : '-' }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.company-name') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.company_name }}</p>
                        </div>
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.project-code') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.project_code }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.participant-name') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.participant_name }}</p>
                        </div>
                        <div class="col-md-6" v-if="!schedule.is_blanco">
                            <p class="fw-bold m-0">{{ __('form.participant-email') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.participant_email }}</p>
                        </div>
                    </div>
                    <div class="row" v-if="!schedule.is_blanco">
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.participant-phone') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.participant_phone }}</p>
                        </div>
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.participant-license-plate') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.participant_license_plate }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.session-date-time') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.start_date_formatted }}</p>
                        </div>
                        <div class="col-md-6">
                            <p class="fw-bold m-0">{{ __('form.location') }}:</p>
                            <p class="mb-1 fw-italic">{{ schedule.location }}</p>
                        </div>
                    </div>
                    <div class="row" v-if="!schedule.is_blanco">
                        <div class="col-md-6">
                            <p class="fw-bold m-0">Contactpersoon locatie:</p>
                            <p class="mb-1 fw-italic">{{ schedule.location_details?.contact_person_name }}</p>
                        </div>
                        <div class="col-md-6">
                            <p class="fw-bold m-0">Contactpersoon tel:</p>
                            <p class="mb-1 fw-italic">{{ schedule.location_details?.contact_person_phone }}</p>
                        </div>
                    </div>
                    <div class="row" v-if="!schedule.is_blanco">
                        <div class="col-md-12">
                            <p class="fw-bold m-0">{{ __('form.notes') }}:</p>
                            <p v-html="schedule.notes_formatted" class="mb-1 fw-italic"></p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn app-btn-secondary" data-bs-dismiss="modal">{{ __('actions.close')
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ViewScheduleModal",

    data() {
        return {
            schedule: null
        }
    },

    mounted: function () {
        $('#viewScheduleModal').on('hide.bs.modal', () => {
            this.schedule = null
        })
    },

    methods: {
        view: function (schedule) {
            this.schedule = schedule
            $('#viewScheduleModal').modal('show')
        },
    }
}
</script>
